// extracted by mini-css-extract-plugin
module.exports =  {"member-avatar":"member-avatar--X2FGH","memberAvatar":"member-avatar--X2FGH","img":"img--Rjvj9","user-name":"user-name--N_WHV","userName":"user-name--N_WHV"};